
import React, { useEffect, useReducer, useState } from 'react';

import { Api } from '../utilities';
import { PromotionContext } from '../context';


const reducer = (state, action) => {
    switch (action.type) {
        case 'SET': {
            return { ...action.payload } || null;
        }
        default:
            return state;
    }
};

export const PromotionProvider = (props) => {
    const [promotion, dispatch] = useReducer(reducer, null);
    const [isPromotionActive, setIsPromotionActive] = useState(false);

    useEffect(() => {
        const getActivePromotion = async () => {
            try {
                const res = await Api.get(`/orders/promotions/`);
                if (res.coupon) {
                    dispatch({ type: 'SET', payload: res });
                } else {
                    dispatch({ type: 'SET', payload: null });
                }
            } catch (error) {
                console.error("Error fetching promotion:", error);
                dispatch({ type: 'SET', payload: null });
            }
        };

        getActivePromotion();
    }, []);

    useEffect(() => {
        if (promotion) {
            const now = new Date();
            setIsPromotionActive(new Date(promotion.end_date) > now);
        } else {
            setIsPromotionActive(false);
        }
    }, [promotion]);

    const hidePromo = () => {
        setIsPromotionActive(false);
    };

    const value = {
        promotion,
        isPromotionActive,
        setIsPromotionActive,
        hidePromo,
    };

    return <PromotionContext.Provider value={value} {...props} />;
};
